"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonLogin = void 0;
const react_1 = __importStar(require("react"));
const lu_1 = require("react-icons/lu");
const auth_1 = require("../../auth");
const brand_1 = require("./brand");
const useOktonTheme_1 = require("../../theme/useOktonTheme");
const loginStyles = {
    page: (dark) => ({
        width: "100vw",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        padding: "24px 16px",
        background: dark ? "#1F2029" : "#3182CE",
        fontFamily: "Roboto, Arial, sans-serif",
    }),
    card: (dark) => ({
        width: "100%",
        maxWidth: 488,
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        padding: 32,
        borderRadius: 16,
        background: dark ? "#353645" : "#FFFFFF",
        boxShadow: "0 1px 3px rgba(0,0,0,.08)",
    }),
    inputWrap: {
        position: "relative",
        width: "100%",
    },
};
function SharedCredentialInput({ name, label, type, value, onChange, icon, dark, }) {
    const [visible, setVisible] = (0, react_1.useState)(false);
    const isPassword = type === "password";
    return (react_1.default.createElement("label", { htmlFor: name, style: {
            display: "block",
            color: dark ? "#fff" : "#353645",
            fontSize: 14,
        } },
        react_1.default.createElement("span", { style: { display: "block", marginBottom: 8, fontWeight: 300 } }, label),
        react_1.default.createElement("span", { style: loginStyles.inputWrap },
            react_1.default.createElement("span", { style: {
                    position: "absolute",
                    left: 16,
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: dark ? "#fff" : "#3182CE",
                    display: "flex",
                } }, icon),
            react_1.default.createElement("input", { id: name, name: name, type: isPassword && visible ? "text" : type, value: value, onChange: (event) => onChange(event.target.value), autoComplete: isPassword ? "current-password" : "username", style: {
                    width: "100%",
                    height: 48,
                    boxSizing: "border-box",
                    padding: isPassword ? "0 48px 0 48px" : "0 16px 0 48px",
                    border: dark ? "1px solid #616480" : "1px solid #D1D2DC",
                    borderRadius: 16,
                    outline: "none",
                    background: dark ? "#1F2029" : "#fff",
                    color: dark ? "#fff" : "#353645",
                    fontSize: 16,
                    fontWeight: 300,
                } }),
            isPassword && (react_1.default.createElement("button", { type: "button", "aria-label": visible ? "Ocultar senha" : "Mostrar senha", onClick: () => setVisible((current) => !current), style: {
                    position: "absolute",
                    right: 14,
                    top: "50%",
                    transform: "translateY(-50%)",
                    border: 0,
                    padding: 4,
                    background: "transparent",
                    color: dark ? "#fff" : "#3182CE",
                    cursor: "pointer",
                    display: "flex",
                } }, react_1.default.createElement((visible ? lu_1.LuEye : lu_1.LuEyeClosed), {
                size: 20,
            }))))));
}
const OktonLogin = (props) => {
    var _a, _b, _c, _d, _e;
    const auth = (0, auth_1.useOptionalOktonAuth)();
    const bootstrap = (_a = props.bootstrap) !== null && _a !== void 0 ? _a : auth === null || auth === void 0 ? void 0 : auth.bootstrap;
    const login = (_b = props.login) !== null && _b !== void 0 ? _b : auth === null || auth === void 0 ? void 0 : auth.login;
    const isLoading = (_d = (_c = props.isLoading) !== null && _c !== void 0 ? _c : auth === null || auth === void 0 ? void 0 : auth.isLoading) !== null && _d !== void 0 ? _d : false;
    const error = (_e = props.error) !== null && _e !== void 0 ? _e : auth === null || auth === void 0 ? void 0 : auth.error;
    const [email, setEmail] = (0, react_1.useState)("");
    const [password, setPassword] = (0, react_1.useState)("");
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const [loginError, setLoginError] = (0, react_1.useState)();
    const { theme, toggleTheme } = (0, useOktonTheme_1.useOktonTheme)();
    const dark = theme === "dark";
    async function handleSubmit(event) {
        event.preventDefault();
        if (!bootstrap || !login || !email || !password)
            return;
        setIsSubmitting(true);
        setLoginError(undefined);
        try {
            await login(email, password);
            if (props.redirectOnSuccess !== false) {
                window.location.replace(props.postLoginUrl || bootstrap.auth.postLoginUrl || "/");
            }
        }
        catch (err) {
            setLoginError(err instanceof Error ? err.message : "Não foi possível entrar.");
        }
        finally {
            setIsSubmitting(false);
        }
    }
    const text = dark ? "#FFFFFF" : "#353645";
    const link = dark ? "#FFFFFF" : "#3182CE";
    return (react_1.default.createElement("div", { style: loginStyles.page(dark) },
        react_1.default.createElement("div", { style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginBottom: 32,
            } },
            react_1.default.createElement("img", { src: dark ? brand_1.oktonLogoWhite : brand_1.oktonLogoWhite, alt: "Okton - Sistemas Empresariais", style: { width: 250, maxHeight: 80, objectFit: "contain" } }),
            (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.system.name) && (react_1.default.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: 12,
                } },
                react_1.default.createElement("div", { style: {
                        color: "#FFFFFF",
                        fontSize: 16,
                        fontWeight: 500,
                        letterSpacing: ".08em",
                        textTransform: "uppercase",
                        textAlign: "center",
                    } }, bootstrap.system.name),
                react_1.default.createElement("div", { style: {
                        marginTop: 8,
                        width: 32,
                        height: 3,
                        borderRadius: 999,
                        background: "#ECC94B",
                    } }),
                bootstrap.system.description && (react_1.default.createElement("div", { style: {
                        marginTop: 8,
                        maxWidth: 360,
                        color: "rgba(255,255,255,.8)",
                        fontSize: 12,
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    } }, bootstrap.system.description))))),
        react_1.default.createElement("form", { onSubmit: handleSubmit, style: loginStyles.card(dark) },
            react_1.default.createElement("div", { style: {
                    display: "grid",
                    gridTemplateColumns: "22px 1fr 22px",
                    alignItems: "center",
                    marginBottom: 16,
                } },
                react_1.default.createElement("span", null),
                react_1.default.createElement("div", { style: {
                        color: text,
                        fontSize: 14,
                        fontWeight: 500,
                        textAlign: "center",
                    } }, "Entre na sua conta"),
                react_1.default.createElement("button", { type: "button", "aria-label": "Alternar tema", onClick: toggleTheme, style: {
                        border: 0,
                        padding: 0,
                        background: "transparent",
                        color: dark ? "#fff" : "#3182CE",
                        cursor: "pointer",
                        display: "flex",
                    } }, react_1.default.createElement((dark ? lu_1.LuMoon : lu_1.LuSun), { size: 22 }))),
            react_1.default.createElement("div", { style: { display: "grid", gap: 16 } },
                react_1.default.createElement(SharedCredentialInput, { name: "email", type: "email", label: "Digitar e-mail", value: email, onChange: setEmail, icon: react_1.default.createElement(lu_1.LuAtSign, { size: 20 }), dark: dark }),
                react_1.default.createElement(SharedCredentialInput, { name: "password", type: "password", label: "Digitar senha", value: password, onChange: setPassword, icon: react_1.default.createElement(lu_1.LuKeyRound, { size: 20 }), dark: dark }),
                (loginError || error) && (react_1.default.createElement("div", { style: { color: "#E53E3E", fontSize: 14, textAlign: "center" } }, loginError || error)),
                props.extraContent ? react_1.default.createElement("div", null, props.extraContent) : null),
            react_1.default.createElement("button", { type: "submit", disabled: !bootstrap ||
                    !login ||
                    !email ||
                    !password ||
                    isLoading ||
                    isSubmitting, style: {
                    marginTop: 24,
                    width: "100%",
                    height: 40,
                    border: 0,
                    borderRadius: 16,
                    background: "#3182CE",
                    color: "#fff",
                    fontSize: 16,
                    fontWeight: 600,
                    cursor: !bootstrap ||
                        !login ||
                        !email ||
                        !password ||
                        isLoading ||
                        isSubmitting
                        ? "not-allowed"
                        : "pointer",
                    opacity: !bootstrap ||
                        !login ||
                        !email ||
                        !password ||
                        isLoading ||
                        isSubmitting
                        ? 0.6
                        : 1,
                } }, isLoading || isSubmitting
                ? props.loadingLabel || "Entrando..."
                : props.submitLabel || "Entrar"),
            react_1.default.createElement("div", { style: {
                    height: 1,
                    background: dark ? "#616480" : "#D1D2DC",
                    margin: "24px 0",
                } }),
            react_1.default.createElement("div", { style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    fontSize: 14,
                } },
                (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.features.forgotPassword) && (react_1.default.createElement("a", { style: { color: link }, href: props.forgotPasswordUrl || "/forgot" }, "N\u00E3o consegue entrar?")),
                (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.features.forgotPassword) &&
                    (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.features.createAccount) && (react_1.default.createElement("span", { style: { color: text } }, "\u2022")),
                (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.features.createAccount) && (react_1.default.createElement("a", { style: { color: link }, href: props.createAccountUrl || "/create-account" }, "Criar uma conta")),
                !(bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.features.forgotPassword) &&
                    !(bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.features.createAccount) && (react_1.default.createElement("span", { style: { color: dark ? "#B3B5C6" : "#616480", fontSize: 12 } }, "Acesso administrado pela identidade Okton"))))));
};
exports.OktonLogin = OktonLogin;
//# sourceMappingURL=OktonLogin.js.map